import React, { forwardRef, useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface CustomQuillEditorProps {
  value: string;
  onChange: (content: string) => void;
  placeholder?: string;
  className?: string;
}

const CustomQuillEditor = forwardRef<HTMLDivElement, CustomQuillEditorProps>(
  ({ value, onChange, placeholder, className = '' }, ref) => {
    const modules = useMemo(() => ({
      toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link', 'blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        ['clean']
      ],
    }), []);

    return (
      <div ref={ref} className={className}>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          placeholder={placeholder}
        />
      </div>
    );
  }
);

CustomQuillEditor.displayName = 'CustomQuillEditor';

export default CustomQuillEditor;
